import type { EvidenceItem, IntervieweeCard } from "../../../domain/contracts";
import { useVillageIncidentChartsPanelData } from "../hooks/useVillageIncidentChartsPanelData";
import { VillageIncidentChartCard } from "./VillageIncidentChartCard";

type VillageIncidentChartsPanelProps = {
  interviewees: IntervieweeCard[];
  evidenceItems: EvidenceItem[];
};

export function VillageIncidentChartsPanel({ interviewees, evidenceItems }: VillageIncidentChartsPanelProps) {
  const {
    chartCards,
    isLoadingDetails,
    isProgressiveLoading,
    loadedDetailCount,
    totalDetailCount,
  } = useVillageIncidentChartsPanelData(interviewees, evidenceItems);

  return (
    <article className="box village-incident-charts fade-in">
      <div className="box-title-row">
        <h3>Evidence and Incident Analytics</h3>
        <span className="small-meta" aria-live="polite">
          {isProgressiveLoading
            ? `Analyzing ${loadedDetailCount}/${totalDetailCount} survivors`
            : ""}
        </span>
      </div>

      {chartCards.length > 0 ? (
        <div className="village-incident-chart-grid">
          {chartCards.map((card) => (
            <VillageIncidentChartCard key={card.id} card={card} />
          ))}
        </div>
      ) : isLoadingDetails ? (
        <p className="small-paragraph">Loading survivor incident data ({loadedDetailCount}/{totalDetailCount})...</p>
      ) : (
        <p className="small-paragraph">No incident or evidence data are available for this village yet.</p>
      )}
    </article>
  );
}
